/**
 * @generated SignedSource<<921f9e04bc04ef12d6f0a929f2edba22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type SchoolExamProblemStatusEnum = "approved" | "rejected" | "review" | "%future added value";
export type SchoolExamProblemSubjectEnum = "english" | "korean" | "math" | "%future added value";
export type SchoolExamSourceActionEnum = "school_exam_source_inner_pdf_upload" | "school_exam_source_publish" | "school_exam_source_reset" | "%future added value";
export type SchoolExamProblemFilter = {
  AND?: SchoolExamProblemFilter | null;
  DISTINCT?: boolean | null;
  NOT?: SchoolExamProblemFilter | null;
  OR?: SchoolExamProblemFilter | null;
  createdById_Exact?: string | null;
  createdById_In?: ReadonlyArray<string> | null;
  modifiedById_Exact?: string | null;
  modifiedById_In?: ReadonlyArray<string> | null;
  problemSubject_Exact?: SchoolExamProblemSubjectEnum | null;
  problemSubject_In?: ReadonlyArray<SchoolExamProblemSubjectEnum> | null;
  search?: string | null;
  status_Exact?: SchoolExamProblemStatusEnum | null;
  status_In?: ReadonlyArray<SchoolExamProblemStatusEnum> | null;
};
export type SchoolExamProblemOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
};
export type SchoolExamScrapOrder = {
  created?: Ordering | null;
  id?: Ordering | null;
  modified?: Ordering | null;
  order?: Ordering | null;
};
export type SchoolExamSourceId_schoolExamSourceQuery$variables = {
  id: string;
  problemFilters?: SchoolExamProblemFilter | null;
  problemOrder?: SchoolExamProblemOrder | null;
  scrapOrder?: SchoolExamScrapOrder | null;
};
export type SchoolExamSourceId_schoolExamSourceQuery$data = {
  readonly schoolExamSource: {
    readonly actions: ReadonlyArray<SchoolExamSourceActionEnum>;
    readonly id: string;
    readonly innerPdf: {
      readonly id: string;
      readonly key: string;
      readonly objectUrl: string;
    } | null;
    readonly problems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly created: any;
          readonly id: string;
          readonly pdf: {
            readonly id: string;
            readonly objectUrl: string;
          } | null;
          readonly sequence: number;
        };
      }>;
      readonly totalCount: number | null;
    };
    readonly school: {
      readonly id: string;
      readonly title: string;
    };
    readonly scraps: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly order: number;
          readonly scrap: {
            readonly id: string;
            readonly objectUrl: string;
          };
          readonly text: string | null;
        };
      }>;
      readonly totalCount: number | null;
    };
    readonly sequence: number;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceDescriptionList_schoolExamSource" | "SchoolExamSourceInnerPdfUploadDialog_schoolExamSource" | "SchoolExamSourceSchoolExamScrapCreateDialog_schoolExamSource" | "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource">;
  };
};
export type SchoolExamSourceId_schoolExamSourceQuery = {
  response: SchoolExamSourceId_schoolExamSourceQuery$data;
  variables: SchoolExamSourceId_schoolExamSourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "problemFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "problemOrder"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scrapOrder"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "School",
  "kind": "LinkedField",
  "name": "school",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "innerPdf",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "problemFilters"
},
v10 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "problemOrder"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v14 = {
  "alias": null,
  "args": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "concreteType": "SchoolExamProblemConnection",
  "kind": "LinkedField",
  "name": "problems",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SchoolExamProblemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SchoolExamProblem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "pdf",
              "plural": false,
              "selections": (v13/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "scrapOrder"
    }
  ],
  "concreteType": "SchoolExamScrapConnection",
  "kind": "LinkedField",
  "name": "scraps",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SchoolExamScrapEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SchoolExamScrap",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "scrap",
              "plural": false,
              "selections": (v13/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v19 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = [
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceId_schoolExamSourceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSource",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceDescriptionList_schoolExamSource"
          },
          (v8/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceInnerPdfUploadDialog_schoolExamSource"
          },
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "scrapOrder",
                "variableName": "scrapOrder"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SchoolExamSourceSchoolExamScrapCreateDialog_schoolExamSource"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceId_schoolExamSourceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamSource",
        "kind": "LinkedField",
        "name": "schoolExamSource",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "examYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "examType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assigned",
            "storageKey": null
          },
          (v8/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": (v19/*: any*/),
            "concreteType": "SchoolExamSourceHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SchoolExamSourceHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolExamSourceHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v2/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "scrapImages",
                                "plural": true,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourcePublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "innerPdf",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "SchoolExamSourceUploadDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v19/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4ad62c2a6bc813b22c2c1cff7b58aa0",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceId_schoolExamSourceQuery",
    "operationKind": "query",
    "text": "query SchoolExamSourceId_schoolExamSourceQuery(\n  $id: ID!\n  $problemFilters: SchoolExamProblemFilter\n  $problemOrder: SchoolExamProblemOrder\n  $scrapOrder: SchoolExamScrapOrder\n) {\n  schoolExamSource(id: $id) {\n    id\n    sequence\n    actions\n    school {\n      id\n      title\n    }\n    title\n    ...SchoolExamSourceDescriptionList_schoolExamSource\n    innerPdf {\n      id\n      key\n      objectUrl\n    }\n    problems(filters: $problemFilters, order: $problemOrder) {\n      totalCount\n      edges {\n        node {\n          id\n          sequence\n          created\n          pdf {\n            id\n            objectUrl\n          }\n        }\n      }\n    }\n    scraps(order: $scrapOrder) {\n      totalCount\n      edges {\n        node {\n          id\n          order\n          text\n          scrap {\n            id\n            objectUrl\n          }\n        }\n      }\n    }\n    ...SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource\n    ...SchoolExamSourceInnerPdfUploadDialog_schoolExamSource\n    ...SchoolExamSourceSchoolExamScrapCreateDialog_schoolExamSource_VxLXj\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment SchoolExamSourceDescriptionList_schoolExamSource on SchoolExamSource {\n  school {\n    id\n    title\n  }\n  schoolYear\n  examYear\n  examType\n  assignedTo {\n    id\n    ...UserAvatarText_user\n  }\n  assigned\n}\n\nfragment SchoolExamSourceHistoryDialog_SchoolExamSourceHistory on SchoolExamSourceHistory {\n  id\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...SchoolExamSourcePublishDifferenceCounterLabel_difference\n    ...SchoolExamSourcePublishDifferenceItemList_difference\n    ...SchoolExamSourceUploadDifferenceCounterLabel_difference\n    ...SchoolExamSourceUploadDifferenceItemList_difference\n  }\n}\n\nfragment SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory on SchoolExamSourceHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment SchoolExamSourceInnerPdfUploadDialog_schoolExamSource on SchoolExamSource {\n  id\n}\n\nfragment SchoolExamSourcePublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourcePublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourcePublishDifference {\n    scrapImages {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment SchoolExamSourceSchoolExamScrapCreateDialog_schoolExamSource_VxLXj on SchoolExamSource {\n  id\n  school {\n    id\n    title\n  }\n  examYear\n  schoolYear\n  examType\n  innerPdf {\n    id\n    objectUrl\n  }\n  scraps(order: $scrapOrder) {\n    edges {\n      node {\n        id\n        order\n      }\n    }\n  }\n  problems(filters: $problemFilters, order: $problemOrder) {\n    edges {\n      node {\n        id\n        sequence\n        created\n        pdf {\n          id\n          objectUrl\n        }\n      }\n    }\n  }\n}\n\nfragment SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource on SchoolExamSource {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...SchoolExamSourceHistoryDialog_SchoolExamSourceHistory\n        ...SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment SchoolExamSourceUploadDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      __typename\n    }\n  }\n}\n\nfragment SchoolExamSourceUploadDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on SchoolExamSourceUploadDifference {\n    innerPdf {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "6402f216d4434e13262da545933711da";

export default node;
